import './style.scss';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Portlet, PortletBody } from 'components/partials/content/Portlet';
// import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { toAbsoluteUrl } from '_metronic';
import { withStyles } from '@material-ui/core/styles';
import { injectIntl } from 'react-intl';
import { getArchitectureBanner } from '../../../bannerImages';

// const WhiteButton = withStyles({
//   root: {
//     color: '#FFF',
//   },
//   outlined: {
//     borderColor: '#FFF',
//   },
// })(Button);

const LabelTypography = withStyles({
  root: {
    fontWeight: 'normal',
    fontSize: '1em',
    color: '#FFF',
  },
})(Typography);

const TitleTypography = withStyles({
  root: {
    fontWeight: 'normal',
    fontSize: '4em',
    color: '#FFF',
  },
})(Typography);

const DescriptionTypography = withStyles({
  root: {
    fontWeight: 'normal',
    fontSize: '1.5em',
    color: '#FFF',
  },
})(Typography);

const ArqMensajeWidget = ({ intl }) => {
  const imgArq = getArchitectureBanner(intl.locale);

  return (
    <Portlet className="kt-portlet--height-fluid">
      <PortletBody
        style={{
          backgroundRepeat: 'no-repeat, repeat',
          backgroundSize: 'cover',
        }}
      >
        <div>
          <img
            src={imgArq}
            style={{
              width: '115%',
              height: '115%',
              marginLeft: '-24px',
              marginTop: '-25px',
            }}
          />
        </div>
      </PortletBody>
    </Portlet>
  );
};

export default injectIntl(ArqMensajeWidget);
